import React from 'react';
import Dropdown from './Dropdown';
import { useStateContext } from '../contexts/ContextProvider';


const GlobalFilter = () => {
    const { currentDept, setDept, currentUser: { depts } } = useStateContext();
    const cityOptions = depts.map((dept) => ({
        label: dept,
        value: dept,
    }))

    return (
        <div className='m-2 md:m-10 mt-24 p-2 md:p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl'>
            <Dropdown
                label="Filtrer par département"
                options={cityOptions}
                value={currentDept}
                onChange={(val) => setDept(val)}
                searchable={false}
                showAllOption={true}
                placeholder="Rechercher un département"
                className="w-72"
            />
        </div>
    )
};

export default GlobalFilter;